'use strict';

var _model = require('./model');

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function Collection(properties) {

    // collections CANNOT be an instanceof Array if the "new" operator is involved. See below create() implementation.
    if (!(this instanceof Array)) {
        throw new Error('you must instantiate collections via Collection.create()');
    }

    _model2['default'].call(this, properties);
}

Object.assign(Collection.prototype, Array.prototype, _model2['default'].prototype, {
    length: 0,
    modelClass: _model2['default'],

    // DEPRECATED  - use bracket syntax instead
    at: function at(index) {
        return this[index];
    },
    createModel: function createModel(properties) {
        var Model = this.modelClass;

        // use factory method if it exists (newer). Otherwise use older method here
        return Model.create ? Model.create(properties) : new Model(properties);
    },
    toJSON: function toJSON() {
        return this.toData();
    },
    toData: function toData() {
        return this.map(function (item) {
            return item && item.toJSON ? item.toJSON() : item;
        });
    },
    onDataChange: function onDataChange(data) {
        this.mergeSourceData(data);
    },
    mergeSourceData: function mergeSourceData(data) {

        var mergedSource = [];

        for (var i = 0, n = data.length; i < n; i++) {
            var newItem = data[i];

            // always create a new model so we can do a proper comparison
            var model = this.createModel({ data: newItem });

            // check existing models to see if we need to update anything
            for (var j = this.length; j--;) {
                var existingItem = this[j];

                // item found? Use that instance instead
                if (existingItem.equals(model)) {
                    existingItem.setProperties({ data: newItem });
                    model = existingItem;
                    break;
                }
            }

            mergedSource.push(model);
        }

        var removedItems = this.filter(function (item) {
            return mergedSource.indexOf(item) === -1;
        });

        this.splice.apply(this, [0, this.length].concat(mergedSource));

        removedItems.forEach(function (item) {
            item.dispose();
        });
    },
    dispose: function dispose() {
        _model2['default'].prototype.dispose.call(this);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = this[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var i = _step.value;
                this[i].dispose();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator['return']) {
                    _iterator['return']();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }

        return this;
    }
});

Collection.extend = _model2['default'].extend;

/**
* creates a new observable collection. This should be used instead of the 'new' operator.
*/

Collection.create = function () {
    var context = [];
    for (var k in this.prototype) {
        context[k] = this.prototype[k];
    }this.apply(context, arguments);
    return context;
};

module.exports = Collection;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/models/base/collection.js
 ** module id = 509
 ** module chunks = 0 1
 **/